import isEqual from 'lodash/isEqual';

import type { OnUpdateDetailPageUrl } from '../HotelOffers/types';
import type { HotelStayType, OnStayChange } from '../types';
import type { SearchControlsOnSubmitParams } from '@shared/hotels-search-controls/types';
import type { I18nService } from '@shared/types/i18n';

import { useHotelOffersActions } from '@hotels-hotel-detail/data-access/hooks/useHotelOffersContext';
import SearchControls, {
  LAYOUT,
} from '@shared/hotels-search-controls/SearchControls';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  onStayChange: OnStayChange;
  updateDetailPageUrl: OnUpdateDetailPageUrl;
  i18n: I18nService;
} & HotelStayType;

const HotelStayDesktop = ({
  destination,
  i18n,
  onStayChange,
  stay,
  updateDetailPageUrl,
}: Props) => {
  const { applyStay } = useHotelOffersActions();

  const onSubmit = (params: SearchControlsOnSubmitParams) => {
    const { checkIn, checkOut, childrenAges, numberOfAdults, numberOfRooms } =
      params;
    const newStay = {
      checkIn,
      checkOut,
      numberOfAdults,
      numberOfRooms,
      childrenAges,
    };

    if (!isEqual(stay, newStay)) {
      onStayChange(newStay);

      applyStay(newStay);

      updateDetailPageUrl({ updatedStay: newStay });
    }
  };

  return (
    <SearchControls
      stay={stay}
      destination={destination}
      shouldAutoSearch
      arrangeInline
      onSubmit={onSubmit}
      layout={LAYOUT.CHAPPED}
      destinationLabel={i18n.translate(
        'SearchControls_label_whereDoYouWantToStay',
      )}
    />
  );
};

export default withI18n(HotelStayDesktop);
